module.exports = __webpack_public_path__ + "static/media/22ESCWA16.d39cef23.jpg";